import Container from '@wearesection/bandai-react-components/atoms/Container';
import {IVerticalScrollingLatestPost} from '@wearesection/bandai-react-components/organisms/VerticalScrollingLatestPost';
import React, {useMemo} from 'react';
import RenderNextImage from '../../atoms/render-next-image';
import {PLACEHOLDER_IMG} from '~/constants';
import dynamic from 'next/dynamic';

const VerticalScrollingLatestPost = dynamic(
  () => import('@wearesection/bandai-react-components/organisms/VerticalScrollingLatestPost')
);

type IVerticalScrollingThumbnailCardExt = IVerticalScrollingLatestPost & {
  locale?: string;
  dataQueryTags?: string[];
  setDataFilterSelected?: Function | null;
  dataQueryGame?: string;
  handlerScroll: Function;
  getNumberValue?: Function;
};

const adapter = (data: IVerticalScrollingThumbnailCardExt) => {
  const IMG_ERROR = PLACEHOLDER_IMG;
  const handleRenderNextImage = (
    src: string,
    width?: string | number,
    height?: string | number,
    alt?: string
  ) => {
    return <RenderNextImage src={src || IMG_ERROR} width={width} height={height} alt={alt} />;
  };

  return {
    title: data?.title ?? '',
    handlerScroll: data.handlerScroll,
    locale: data.locale,
    listThumbnail: [],
    dataQueryTags: data.dataQueryTags ?? [],
    nextImage: handleRenderNextImage,
  };
};

const VerticalScrollingLatestPostOrganisms: React.FC<
  IVerticalScrollingThumbnailCardExt
> = props => {
  const renderNextImageProps = (src: string, title: string) => {
    return (
      <RenderNextImage src={src ?? PLACEHOLDER_IMG} width={547} height={306} alt={title || ''} />
    );
  };
  const VerticalScrollingThumbnailCardOrganismsProps = useMemo(() => adapter(props), [props]);

  return (
    <Container>
      <VerticalScrollingLatestPost
        getNumberValue={(e: number) => props.getNumberValue?.(e as number)}
        {...VerticalScrollingThumbnailCardOrganismsProps}
        mainImageNextProps={renderNextImageProps}
      />
    </Container>
  );
};

export default VerticalScrollingLatestPostOrganisms;
